import React, {InputHTMLAttributes} from 'react'

const Input: React.FC<{
    value: string;
    change: (value: string) => void;
    className?: string;
    children?: (attrs: InputHTMLAttributes<any>) => React.ReactNode;
    onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
}> = (props) => {
    function onChange(e: React.FormEvent<HTMLInputElement>) {
        props.change((e.target as HTMLInputElement).value)
    }

    if (props.children) {
        return <>
            {props.children({
                value: props.value,
                onInput: onChange
            })}
        </>
    }

    return <input type="text" className={'input ' + props.className} onPaste={props.onPaste} value={props.value} onInput={onChange}/>
}

export default Input
